import React from 'react';
import { FileText } from 'lucide-react';
import LclBoardPage from './LclBoardPage';
import {
  SUBESTADOS_COTIZACIONES,
  VENCIDA_DIAS,
} from '../utils/lclBoardConstants';

/**
 * Tablero "Cotizaciones" — solicitudes LCL en estado `Borrador`.
 *
 * Sub-estados:
 *  - "Borrador"            : recién creada, sin enviar
 *  - "Enviada"             : mandada al cliente
 *  - "Esperando respuesta" : enviada, sin respuesta
 *  - "Vencida"             : pasó el umbral de días sin respuesta (derivado)
 */

const daysSince = (v) => {
  if (!v) return 0;
  const d = new Date(v);
  if (isNaN(d.getTime())) return 0;
  return Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
};

/**
 * "Vencida" no se guarda: se deriva de la antigüedad. Solo aplica a
 * las que ya salieron al cliente ("Enviada" / "Esperando respuesta");
 * una que sigue en borrador no vence.
 */
const computeSubEstado = (r) => {
  const se = r?.subEstado || 'Borrador';
  if (se === 'Enviada' || se === 'Esperando respuesta') {
    return daysSince(r.updatedAt || r.createdAt) > VENCIDA_DIAS ? 'Vencida' : se;
  }
  return se;
};

export default function LclQuotationsBoardPage() {
  return (
    <LclBoardPage
      estado="Borrador"
      titulo="Cotizaciones LCL"
      subtitulo="Solicitudes en estado Borrador · gestioná sub-estados y transiciones"
      icon={FileText}
      iconClass="bg-amber-100 text-amber-700"
      subEstadoOptions={SUBESTADOS_COTIZACIONES}
      subEstadoDefault="Borrador"
      computeSubEstado={computeSubEstado}
      mostrarAntiguedad
      exportFileName="lcl_cotizaciones"
      permiteInvitar
      permiteCargarCotizacion
    />
  );
}
